<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path d="M4 0.5C4 0.223858 3.77614 0 3.5 0C3.22386 0 3 0.223858 3 0.5V3H0.5C0.223858 3 0 3.22386 0 3.5C0 3.77614 0.223858 4 0.5 4H3V10.5C3 11.8807 4.11929 13 5.5 13H12V15.5C12 15.7761 12.2239 16 12.5 16C12.7761 16 13 15.7761 13 15.5V13H15.5C15.7761 13 16 12.7761 16 12.5C16 12.2239 15.7761 12 15.5 12H5.5C4.67157 12 4 11.3284 4 10.5V0.5ZM12 5.5V11H13V5.5C13 4.11929 11.8807 3 10.5 3H5V4H10.5C11.3284 4 12 4.67157 12 5.5Z" />
  </svg>
</template>
